import { Assumption, Cost } from '@/data/fields'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

export const vuexPersist = new VuexPersist({
  key: 'mla-pic',
  storage: window.localStorage
})

export type LifeCycle = 'Perennial' | 'Short Term'

export interface Scenario {
  text: string,
  date: Date,
  value: {
    name: string,
    areas: number,
    lifeCycle: LifeCycle,
    totals: any,
    costs: Cost[],
    assumptions: Assumption[]
  }
}

const getDefaultState = () => {
  return {
    resetData: false,
    resetDisable: false,
    activeTab: 'home' as string,
    calculatorTab: 0 as number,
    errors: [] as string[],
    errorAlert: false as boolean,
    rules: {
      required: (value:any) => (!!value || value === 0) || 'Required.',
      notNegative: (value:number) => value >= 0 || 'No negative values.',
      notZero: (value:number) => value != 0 || 'Number must be greater than 0.'
    },
    selectedScenario: null as any,
    scenarios: [] as Scenario[]
  }
}

const state = getDefaultState()

export default new Vuex.Store({
  state: state,
  mutations: {
    resetState (state: any, clearLocalStorage:boolean) {
      if (clearLocalStorage === false) {
        const scenarios = JSON.parse(window.localStorage['mla-pic']).scenarios
        Object.assign(state, getDefaultState())
        state.scenarios = scenarios
      } else {
        localStorage.removeItem('mla-pic');
        Object.assign(state, getDefaultState())
      }
    },
    resetDisable (state: any, disable) {
      state.resetDisable = disable
    },
    scenarios (state, updatedState) {
      state.scenarios = updatedState
    },
    selectedScenario (state, updatedState) {
      state.selectedScenario = updatedState
    }
  },
  actions: {
    resetState ({ commit }, clearLocalStorage) {
      commit('resetState', clearLocalStorage)
    },
    resetDisable ({ commit }, disable) {
      commit('resetDisable', disable)
    },
    updateScenarios ({ commit }, updatedState) {
      commit('scenarios', updatedState)
    },
    updateSelectedScenario ({ commit }, updatedState) {
      commit('selectedScenario', updatedState)
    }
  },
  plugins: [vuexPersist.plugin]
})
